import cn from 'classnames';
import { HTMLAttributes } from 'react';

import { ITag, TagStatus } from './';

const statusClasses: Record<TagStatus, string> = {
  active: `bg-grey-20 text-grey-80 rounded-full duration-300
    dark:text-white dark:bg-white
    hover:bg-50 hover:text-white
    active:bg-50 active:text-white
    disabled:text-grey-40 disabled:border-0 disabled:bg-grey-20
    focus:outline focus:bg-grey-80 focus:outline-6 focus:outline-grey-20 focus:text-white`,
  inactive: `bg-transparent text-black border border-black rounded-full border-2 duration-300
    dark:text-white dark:border-white
    cursor-auto hover:cursor-auto
    active:border-grey-40 active:outline-0
    disabled:text-grey-40 disabled:border-grey-40
    focus:border-grey-40 focus:text-grey-80 focus:outline focus:outline-0 focus:outline-grey-40`,
};

export function Tag(props: ITag & HTMLAttributes<HTMLElement>) {
  const { className, status = 'inactive', label = '', ...rest } = props;
  const Elm = status === 'inactive' ? 'div' : 'button';
  return (
    <div className={cn(className, 'flex')}>
      <Elm {...rest} className={cn(statusClasses[status], 'py-0.5 px-2.5')}>
        <span className={cn('text-size13 capitalize')}>{label}</span>
      </Elm>
    </div>
  );
}
